<template>
    <v-card elevation="0" style="width: 100%; background-color: #F1F1F1" class="mr-auto ml-auto px-8" v-if="languageData.messages">
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>
              <strong>{{ snackbar.title }}</strong>
            </div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
          <template v-if="dataSubscription.isSubscribing">
            <v-row justify="center" class="px-5 pt-10 pb-2" style="background-color: #fff">
              <p v-html="languageData.messages.subscriptionActive + ' ' + dataSubscription.valid_until"></p>
            </v-row>
            <v-row justify="center" class="pb-5 mb-8" style="background-color: #fff">
              <v-btn @click="goToCompany()" color="primary">{{ languageData.btnRedirectCompany }}</v-btn>
            </v-row>
          </template>
          <template v-else>
            <v-row justify="center" class="px-5 pt-10 pb-2 mb-8" style="background-color: #fff">
              <p v-html="languageData.messages.subscriptionExpired + ' ' + dataSubscription.valid_until"></p>
            </v-row>
            <v-row class="payment-buttons-container">
               <div class="payment-buttons-block">
                 <v-row justify="center" class="mt-4 flex-column text-center">
                  <p class="subscription-header">{{ languageData.oneMonthSub }}</p>
                   <span class="text-lg font-italic">{{ languageData.cancellable }}</span>
                 </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-price">{{ getSubscriptionPlanPrice(1) + '€' }}
                    <span>{{ ' ' +  languageData.per_month}}</span>
                  </p>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-total-price">{{ languageData.total + ' ' + getSubscriptionPlanPrice(1) + '€' }}</p>
                </v-row>
                <v-row justify="center" class="stripe-checkout-button-container">
                  <v-btn class="stipe-checkout-button" x-large :loading="stripeIsFetching1" @click="redirectToStripePayment(1)">
                    <span>{{languageData.checkout_stripe}}</span>
                  </v-btn>
                  <v-btn class="stipe-checkout-button--price" x-large @click="redirectToStripePayment(1)">
                    <span>{{ getSubscriptionPlanPrice(1) + '€' }}</span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mt-7">
                    <div style="width: 385px; height: 60px" :id="'paypal-button-container' + getPaypalPlanId(1)" />
                </v-row> 
              </div>
              <div class="payment-buttons-block">
                <v-row justify="center" class="mt-4 flex-column text-center">
                  <p class="subscription-header">{{ languageData.threeMonthSub }}</p>
                  <span class="text-lg font-italic">{{ languageData.cancellable }}</span>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-price">{{  (getSubscriptionPlanPrice(3) / 3).toFixed(2) + '€' }}
                    <span>{{ ' ' +  languageData.per_month}}</span>
                  </p>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-total-price">{{ languageData.total + ' ' + getSubscriptionPlanPrice(3) + '€' }}</p>
                </v-row>
                <v-row justify="center" class="stripe-checkout-button-container">
                  <v-btn class="stipe-checkout-button" x-large :loading="stripeIsFetching3" @click="redirectToStripePayment(3)">
                    <span>{{languageData.checkout_stripe}}</span>
                  </v-btn>
                  <v-btn class="stipe-checkout-button--price" x-large @click="redirectToStripePayment(3)">
                    <span>{{ getSubscriptionPlanPrice(3) + '€' }}</span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mt-7">
                    <div style="width: 385px; height: 60px" :id="'paypal-button-container' + getPaypalPlanId(3)" />
                </v-row> 
              </div>
              <div class="payment-buttons-block">
                <v-row justify="center" class="mt-4 flex-column text-center">
                    <p class="subscription-header">{{ languageData.sixMonthSub }}</p>
                    <span class="text-lg font-italic">{{ languageData.cancellable }}</span>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-price">{{ (getSubscriptionPlanPrice(6) / 6).toFixed(2) + '€' }}
                    <span>{{ ' ' +  languageData.per_month}}</span>
                  </p>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-total-price">{{ languageData.total + ' ' + getSubscriptionPlanPrice(6) + '€' }}</p>
                </v-row>
                <v-row justify="center" class="stripe-checkout-button-container">
                  <v-btn class="stipe-checkout-button" x-large :loading="stripeIsFetching6" @click="redirectToStripePayment(6)">
                    <span>{{languageData.checkout_stripe}}</span>
                  </v-btn>
                  <v-btn class="stipe-checkout-button--price" x-large @click="redirectToStripePayment(6)">
                    <span>{{ getSubscriptionPlanPrice(6) + '€' }}</span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mt-7">
                    <div style="width: 385px; height: 60px" :id="'paypal-button-container' + getPaypalPlanId(6)" />
                </v-row> 
              </div>
              <div class="payment-buttons-block">
                <v-row justify="center" class="mt-4 flex-column text-center">
                  <p class="subscription-header">{{ languageData.twelveMonthSub }}</p>
                  <span class="text-lg font-italic">{{ languageData.cancellable }}</span>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-price">{{ (getSubscriptionPlanPrice(12) / 12).toFixed(2) + '€' }}
                    <span>{{ ' ' +  languageData.per_month}}</span>
                  </p>
                </v-row>
                <v-row justify="center" class="mt-4">
                  <p class="subscription-total-price">{{ languageData.total + ' ' + getSubscriptionPlanPrice(12) + '€' }}</p>
                </v-row>
                <v-row justify="center" class="stripe-checkout-button-container">
                  <v-btn class="stipe-checkout-button" x-large :loading="stripeIsFetching12" @click="redirectToStripePayment(12)">
                    <span>{{languageData.checkout_stripe}}</span>
                  </v-btn>
                  <v-btn class="stipe-checkout-button--price" x-large @click="redirectToStripePayment(12)">
                    <span>{{ getSubscriptionPlanPrice(12) + '€' }}</span>
                  </v-btn>
                </v-row>
                <v-row justify="center" class="mt-7">
                    <div style="width: 385px; height: 60px" :id="'paypal-button-container' + getPaypalPlanId(12)" />
                </v-row> 
              </div>
            </v-row>       
        </template>
    </v-card>
</template>


<script>
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";
import router from "../../../../../router";

export default {
  name: "SubscriptionInfo",
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        corner: 'right',
        timeout: 7500,
        title: null,
        visible: false
      },
      sdkLoaded: false
    }
  },
  computed: {
    ...mapState('getSubscription', {
      dataSubscription: state => state.dataSubscription,
    }),
    ...mapState('subscribe', {
      isFetching: state => state.isFetching,
      stripeIsFetching1: state => state.stripeIsFetching1,
      stripeIsFetching3: state => state.stripeIsFetching3,
      stripeIsFetching6: state => state.stripeIsFetching6,
      stripeIsFetching12: state => state.stripeIsFetching12,
      paypalPlanData: state => state.subscriptionPaypalPlan,
      paypalSubscibed: state => state.isPaypalSubscribed,
      stripePaymentLink: state => state.paymentStripeLink,
      subscriptionPlans: state => state.subscriptionPlans,
    }),
  },
  methods: {
    ...mapActions('subscribe', ['sendSubscribeLinkRequest', 'sendSubscribeStripeLink', 'getSubscriptionPlans', 'getPaypalPlans', 'subscribePaypal']),

    sendSubscriptionRequest() {
      this.sendSubscribeLinkRequest();
    },
    redirectToStripePayment(interval) {
      this.sendSubscribeStripeLink({ interval });
    },
    goToCompany() {
      router.push({path: '/companies/my'})
    },
    getSubscriptionPlanPrice(interval) {
      if (this.subscriptionPlans) {
        const price = this.subscriptionPlans.filter(el => el.interval === interval)[0].price;
        return price / 100
      }
      
    },
    loadSdkScript () {
      return new Promise(resolve => {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.paypal.com/sdk/js?client-id=' + this.paypalPlanData.client_id + '&vault=true&intent=subscription'
        script.onload = () => {
          this.sdkLoaded = true
          resolve()
        }
        document.body.appendChild(script)
      })
    },
    renderButton (interval) {
      const planId = this.getPaypalPlanId(interval);
      window.paypal
        .Buttons({
          style: {
            shape: 'rect',
            color: 'gold',
            layout: 'horizontal',
            label: 'paypal',
            tagline: false
          },
          createSubscription: (data, actions) => {
            return actions.subscription.create({
            'plan_id': planId,
            'custom_id': this.paypalPlanData.user_id,
          });
          },
          onApprove: (data) => {
            this.subscribePaypal({
            user_id: this.paypalPlanData.user_id,
            plan_id: this.paypalPlanData.plan_id,
            subscription_id: data.subscriptionID,
            interval
          });
          },
          onError: this.onError
        })
        .render('#paypal-button-container' + this.getPaypalPlanId(interval))  
    },
    onError () {
      console.log('payment error');
    },
    getPaypalPlanId(interval) {
      if (this.paypalPlanData) {
        const paypalPlan = this.paypalPlanData.plans.filter(el => el.interval === interval)[0];
        return paypalPlan.plan_id
      } 
    },
    getSnackbarSuccess: function (title, message, color) {
      this.snackbar = {
        color: color,
        icon: "check_circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    }
  },
  watch: {
      async paypalPlanData() {
        await this.loadSdkScript();
        setTimeout(() => {
          this.renderButton(1);
          this.renderButton(3);
          this.renderButton(6);
          this.renderButton(12);
        }, 250)      
    },
    paypalSubscibed(newValue) {
      if (newValue) {
        window.location.href = this.paypalPlanData.success_redirect_url;
      }
    },
    "dataSubscription.isSubscribing" (newValue) {
      if (!newValue === true) {
        this.getPaypalPlans();    
      }
    }
  },
  mounted() {
    eventBus.$on('sendSubscribeLinkSuccess', (data) => {
      window.location.href = data.url
    });

    eventBus.$on('sendSubscribeStripeLinkSuccess', (data) => {
      window.location.href = data.url
    });

    if(this.$route.query.checkPayment === 'true') {
      eventBus.$on('setSubscriptionStatus', (isSubscribing) => {
        if(isSubscribing) {
          this.getSnackbarSuccess('Thank you for your payment', 'We invite you to use our system', 'success')
        }
      })
    } else if (this.$route.query.checkPayment === 'false') {
      this.getSnackbarSuccess('Payment failed', 'Please try then later or contact with administrator', 'error')
    }
    
    this.getSubscriptionPlans();
  },
  beforeDestroy() {
    eventBus.$off('sendSubscribeLinkSuccess');
    eventBus.$off('sendSubscribeStripeLinkSuccess');
  }
}
</script>

<style src="./SubscriptionInfo.scss" lang="scss"></style>

